import {Injectable} from '@angular/core';
import {AbstractStationService} from './abstract-station.service';
import {CreateStationComponentDto, StationComponentDto} from "@shared/dto";

@Injectable({
  providedIn: 'root'
})
export class StationComponentService extends AbstractStationService<StationComponentDto, CreateStationComponentDto, any> {
}
